import { EPointSearchOperator } from '../../../points/point-search/point-search.consts';
import {
  EReminderFilterKeys,
  EReminderFilterType,
} from '../../../reminders/reminder-filters/reminder-filters.consts';

export const GET_DEFAULT_REMINDER_FILTERS = (): {
  keys: EReminderFilterType[];
  values: EReminderFilterKeys[];
  operator: EPointSearchOperator;
}[] => [
  {
    keys: [EReminderFilterType.TYPE],
    values: [
      EReminderFilterKeys.SHARED_BY_ME,
      EReminderFilterKeys.SHARED_WITH_ME,
      EReminderFilterKeys.PERSONAL,
    ],
    operator: EPointSearchOperator.IN,
  },
  {
    keys: [EReminderFilterType.STATUS],
    values: [
      EReminderFilterKeys.UPCOMING,
      EReminderFilterKeys.DISMISSED,
      EReminderFilterKeys.OVERDUE,
    ],
    operator: EPointSearchOperator.IN,
  },
  {
    keys: [EReminderFilterType.LINKED_TO],
    values: [EReminderFilterKeys.LINKED, EReminderFilterKeys.WITHOUT_LINK],
    operator: EPointSearchOperator.IN,
  },
];
